import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    underline: {
        backgroundColor: '#E3E4FA',
        border: '5px solid #E3E4FA',
        borderRadius: '10px',
        height: '0'
    },
    underlineError: {
        backgroundColor: '#FF0000',
        border: '5px solid #FF0000'
    }
}));

const DEFAULT_MARGIN_BOTTOM = '20px';

const Underline = ({
    disabled,
    marginBottom = DEFAULT_MARGIN_BOTTOM
}: {
    disabled?: boolean | null | string;
    marginBottom?: string;
}): JSX.Element => {
    const classes = useStyles();

    const underlineClass = disabled
        ? `${classes.underlineError} ${classes.underline}`
        : classes.underline;

    return <div className={underlineClass} style={{ marginBottom }} />;
};

export default Underline;
